// App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import {
  Navbar,
  MainSection,
  NextSection,
  TechSection,
  LoginSection,
  HeroSection,
  ContactSection,
  CompanySection,
  LoadingAnimation,
} from './components';

import BlogSection from './components/BlogSection';
import Blog from './components/Blogs';
import FooterSection from './components/FooterSection';
import './App.css';
import BlogDetails from './components/BlogDetails';


// Industry Pages
import Industries_AccountingFinance from './components/Industries_AccountingFinance';
import Industries_Education from './components/Industries_Education';
import Industries_EnergyUtilities from './components/Industries_EnergyUtilities';
import Industries_GovernmentPublic from './components/Industries_GovernmentPublic';
import Industries_LegalLawFirm from './components/Industries_LegalLawFirm';
import Industries_Manufacturing from './components/Industries_Manufacturing';
import Industries_Portfolio from './components/Industries_Portfolio';


// Leadership Page
import LeadershipMessage from "./components/leadership-message";

// upcomoimg project Page 
import SmartWatch from "./components/upcoming-project/smart-watch-mdm";
import FinanceTabPhone from "./components/upcoming-project/finance-approved-tablet-phone";
import VrGlasses from "./components/upcoming-project/vr-glasses";
import MlModule from "./components/upcoming-project/ml-module";




// Service Pages
import Services from './components/services';
import Services_AndroidZeroTouchEnrollment from './components/Services_AndroidZeroTouchEnrollment';
import Services_AndroidManagement from './components/Services_AndroidManagement';
import Services_CloudComputing from './components/Services_CloudComputing';
import Services_CloudManagementService from './components/Services_CloudManagementService';
import Services_CyberSecurity from './components/Services_CyberSecurity';
import Services_IOSManagement from './components/Services_IOSManagement';
import Services_MobileManagement from './components/Services_MobileManagement';
import Services_ITManagement from './components/Services_ITManagement';
import Services_ITSupport from './components/Services_ITSupport';
import Services_SoftwareDevelopment from './components/Services_SoftwareDevelopment';
import Services_DigitalMarketing from './components/Services_DigitalMarketing';

import BuildAutomateGrowPage from './components/BuildAutomateGrowPage';

// ---------- Layout Wrapper ----------
const Layout = ({ children }) => (
  <>
    {children}
    <FooterSection />
  </>
);

function App() {
  const [loading, setLoading] = useState(true);

  const handleLoadingComplete = () => setLoading(false);

  return (
    <>
      {loading && <LoadingAnimation onLoadingComplete={handleLoadingComplete} />}

      {!loading && (
        <Router>
          <Navbar />
          <Layout>
            <Routes>
              {/* Home */}
              <Route path="/" element={<Home />} />

              {/* Company */}
              <Route path="/company" element={<Company />} />
              <Route path="/leadership-message" element={<LeadershipMessage />} />



              {/* Portfolio */}
              <Route path="/portfolio" element={<Industries_Portfolio />} />

              {/* Services */}
              <Route path="/services" element={<Services />} />
              <Route path="/services/android-zero-touch-enrollment" element={<Services_AndroidZeroTouchEnrollment />} />
              <Route path="/services/android-management" element={<Services_AndroidManagement />} />
              <Route path="/services/cloud-computing" element={<Services_CloudComputing />} />
              <Route path="/services/cloud-management-service" element={<Services_CloudManagementService />} />
              <Route path="/services/cyber-security" element={<Services_CyberSecurity />} />
              <Route path="/services/ios-management" element={<Services_IOSManagement />} />
              <Route path="/services/mobile-management" element={<Services_MobileManagement />} />
              <Route path="/services/it-management" element={<Services_ITManagement />} />
              <Route path="/services/it-support" element={<Services_ITSupport />} />
              <Route path="/services/software-development" element={<Services_SoftwareDevelopment />} />
              <Route path="/services/digital-marketing" element={<Services_DigitalMarketing />} />

              {/* Industries */}
              <Route path="/industries/accounting-finance" element={<Industries_AccountingFinance />} />
              <Route path="/industries/education" element={<Industries_Education />} />
              <Route path="/industries/energy-utilities" element={<Industries_EnergyUtilities />} />
              <Route path="/industries/government-public" element={<Industries_GovernmentPublic />} />
              <Route path="/industries/legal-law-firm" element={<Industries_LegalLawFirm />} />
              <Route path="/industries/manufacturing" element={<Industries_Manufacturing />} />

              {/* Blog */}
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogDetails />} />

              {/* Upcomimg Project */}
              <Route path="/upcoming-project/smart-watch-mdm" element={<SmartWatch />} />
              <Route path="/upcoming-project/finance-approved-tablet-phone" element={<FinanceTabPhone />} />
              <Route path="/upcoming-project/vr-glasses" element={<VrGlasses />} />
              <Route path="/upcoming-project/ml-module" element={<MlModule />} />


              {/* Contact */}
              <Route path="/contact" element={<Contact />} />

              {/* Consultant */}
              <Route path="/consultant" element={<Consultant />} />

              {/* Future */}
              <Route path="/future" element={<BuildAutomateGrowPage />} />
            </Routes>
          </Layout>
        </Router>
      )}
    </>
  );
}

// ---------- Pages ----------
const Home = () => (
  <div className="page-container">
    <HeroSection />
    <MainSection />
    <NextSection />
    <TechSection />
    <Industries_Portfolio />
    <LoginSection />
   
  </div>
);

const Company = () => (
  <div className="company-page">
    <CompanySection />
  </div>
);

const Contact = () => (
  <div className="contact-page">
    <ContactSection />
  </div>
);

const Consultant = () => (
  <div className="page-container">
    Get Free Consultant Page
  </div>
);

export default App;
